import { colors } from '@flowwai-frontend/shared/style-guide'

export const portalsTheme = {
   light: {
      common: {
         baseBgColor: 'bg-base-white',
         selectedContainerBorderColor: 'border-primary-600',
         tabsTitleTextColor: 'text-gray-600',
         selectedTabTitleTextColor: 'text-primary-600',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         defaultBorderColor: 'border-gray-300',
         headerBgColor: 'bg-base-white',
         popoverMenuHoverBgColor: 'hover:bg-gray-100'
      },
      portal: {
         defaultBgColor: 'bg-base-white',
         cardHoverBorderColor: 'border-gray-300',
         publishedTextColor: 'text-success-700',
         unpublishedTextColor: 'text-gray-700',
         createdByTextColor: 'text-gray-600'
      },
      portals: {
         bgColor: 'bg-gray-100'
      },
      applicationTabPopoverMenu: {
         deleteButtonTextColor: 'text-error-600',
         editButtonTextColor: 'text-gray-900',
         deleteIconFilColor: colors['error-600'],
         editIconFilColor: colors['gray-500']
      },
      portalDetailedView: {
         applicationsBGColor: 'bg-gray-100',
         applicationsTitleColor: 'text-gray-900',
         applicationNameColor: 'text-gray-700',
         applicationBGColor: 'bg-base-white',
         copyIconColor: colors['primary-600'],
         settingsIconColor: colors['gray-700'],
         backIconColor: colors['gray-700'],
         headerBorderColor: 'border-gray-300',
         headerTitleTextColor: 'text-gray-900',
         headerBackTextColor: 'text-primary-600',
         createPortalApplication: {
            bgColor: 'bg-base-white',
            titleTextColor: 'text-gray-900',
            descriptionTextColor: 'text-gray-600',
            pipelineCustomOptionHoverBgColor: 'hover:bg-gray-50',
            pipelineCustomOptionSelectedPipelineBGColor: 'bg-gray-50',
            tickIconColor: colors['primary-600'],
            closeIconColor: colors['gray-500']
         }
      },
      applicationConfigurations: {
         titleColor: 'text-gray-700',
         descriptionColor: 'text-gray-600',
         selectedTextColor: 'text-gray-500'
      },
      overviewFieldsList: {
         dotsMoveIconFillColor: colors['gray-400'],
         eyeIconColor: colors['gray-500'],
         plusIconColor: colors['primary-600'],
         textColor: 'text-gray-700',
         fieldIconColor: colors['gray-500']
      }
   },
   dark: {}
}
